import { render, staticRenderFns } from "./registerSectorStep2Page.vue?vue&type=template&id=002d010f&scoped=true&"
import script from "./registerSectorStep2Page.vue?vue&type=script&lang=js&"
export * from "./registerSectorStep2Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002d010f",
  null
  
)

export default component.exports